import React, { useState } from "react";
import {
  Box,
  Flex,
  Image,
  Text,
  Stack,
  FormControl,
  Input,
  Checkbox,
  Link,
  Button,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useForm } from "react-hook-form";
import logoLogin from "../../assets/images/logo-main.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import background from "../../assets/images/background-login.png";
import { loginUser } from "../../redux/slices/apiRequestsSlice";
const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.fcm);
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      phone: "",
      password: "",
    },
  });

  const passwordValue = watch("password");

  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async (data) => {
    setIsLoading(true);
    const { phone, password } = data;
    const newUser = {
      phone,
      password,
    };

    await loginUser(newUser,  token, dispatch, navigate);
    setIsLoading(false);
  };
  return (
    <Flex
      backgroundImage={`url(${background})`}
      backgroundRepeat={"no-repeat"}
      backgroundColor="var(--color-background)"
      h={"100vh"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Box
        padding={{ base: "40px" }}
        borderRadius={{ base: "16px" }}
        w={{ base: "500px" }}
        minHeight={{ base: "500px" }}
        backgroundColor="var(--color-main)"
        position={"relative"}
      >
        <Flex
          h={"100%"}
          w={"100%"}
          flexDirection={{ base: "column" }}
          alignItems={{ base: "center" }}
        >
          <Image src={logoLogin} />
          <Text
            fontSize={{ base: "26px" }}
            fontWeight={600}
            mt={{ base: "23px" }}
            mb={{ base: "36px" }}
          >
            Đăng nhập
          </Text>
          <Box w={"100%"}>
            <form onSubmit={handleSubmit(handleSignIn)}>
              <Flex flexDirection={{ base: "column" }}>
                <FormControl mb={{ base: "16px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Tên đăng nhập
                  </Text>
                  <Input
                    fontSize={{ base: "14px" }}
                    padding={"0px"}
                    borderRadius={"0px"}
                    border={"none"}
                    borderBottom={"1px solid #E1E1E1"}
                    placeholder="Nhập số điện thoại hoặc mã nhân viên"
                    _focus={{
                      boxShadow: "none",
                      borderColor: "#E1E1E1",
                    }}
                    {...register("phone", {
                      required: "Tên đăng nhập là bắt buộc",
                    })}
                  />
                  {errors.phone && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.phone.message}
                    </Text>
                  )}
                </FormControl>
                <FormControl id="password" mb={{ base: "13px" }}>
                  <Text fontSize={{ base: "12px" }} fontWeight={500}>
                    Mật khẩu
                  </Text>
                  <InputGroup>
                    <Input
                      fontSize={{ base: "14px" }}
                      padding={"0px"}
                      borderRadius={"0px"}
                      border={"none"}
                      borderBottom={"1px solid #E1E1E1"}
                      type={showPassword ? "text" : "password"}
                      placeholder="Nhập mật khẩu "
                      _focus={{
                        boxShadow: "none",
                        borderColor: "#E1E1E1",
                      }}
                      {...register("password", {
                        required: "Mật khẩu là bắt buộc",
                      })}
                    />
                    {passwordValue && (
                      <InputRightElement>
                        <IconButton
                          _hover={{
                            bg: "var(--color-main)",
                          }}
                          backgroundColor={"none"}
                          icon={showPassword ? <ViewIcon /> : <ViewOffIcon />}
                          onClick={() => setShowPassword(!showPassword)}
                          variant="ghost"
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        />
                      </InputRightElement>
                    )}
                  </InputGroup>
                  {errors.password && (
                    <Text fontSize={{ base: "12px" }} color={"red"}>
                      {errors.password.message}
                    </Text>
                  )}
                </FormControl>
                <Stack
                  fontSize={{ base: "12px" }}
                  direction="row"
                  justify="space-between"
                  align="center"
                  pb={{ base: "58px" }}
                >
                  <Checkbox>
                    <Text
                      fontSize={{ base: "13px" }}
                      lineHeight={"normal"}
                      color="var(--color-info-employee)"
                    >
                      Lưu mật khẩu
                    </Text>
                  </Checkbox>
                  <Link
                    href="/forgot"
                    color="var(--color-option-employee-hover)"
                    fontSize={"13px"}
                    fontWeight={600}
                    lineHeight={"normal"}
                  >
                    Quên mật khẩu?
                  </Link>
                </Stack>
                <Button
                  isLoading={isLoading}
                  isDisabled={isLoading}
                  backgroundImage="var(--color-button)"
                  _hover={{
                    backgroundImage: "var(--color-button)",
                  }}
                  type="submit"
                >
                  <Text
                    color={"#FFF"}
                    fontSize={{ base: "15px" }}
                    fontWeight={700}
                  >
                    Đăng nhập
                  </Text>
                </Button>
                <Flex justifyContent={"center"} mt={{ base: "18px" }}>
                  <Link
                    onClick={() => navigate("/nv/login")}
                    color="var(--color-option-employee-hover)"
                    fontSize={"13px"}
                    fontWeight={600}
                  >
                    Đăng nhập cổng nhân viên →
                  </Link>
                </Flex>
              </Flex>
            </form>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default SignIn;
